import React from 'react';
import { componentService } from 'js/services/component.service';

export const BetLossLimits = React.lazy(() => import(/* webpackChunkName: "responsible-gaming" */ './Limits'));
export const LoginLimits = React.lazy(() => import(/* webpackChunkName: "responsible-gaming" */ './LoginLimits'));

componentService.registerPageComponents({
    responsiblegamingbetlimits: BetLossLimits,
    responsiblegaminglosslimits: BetLossLimits,
    responsiblegamingloginlimits: LoginLimits
});
